"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ActionTypes_1 = require("../actions/ActionTypes");
var elstrUserReducer = function (state, action) {
    if (!state)
        return null;
    switch (action.type) {
        case ActionTypes_1.ElstrUserActionsTypes.ELSTR_USER_DID_LOGIN:
            if (action.payload.action === "success") {
                // delete unnecessary key value pair
                delete action.payload.action;
                return __assign(__assign({}, state), action.payload);
            }
            break;
        case ActionTypes_1.ElstrUserActionsTypes.ELSTR_USER_DID_LOGOUT:
            if (action.payload.action === "success") {
                var user = {
                    username: "anonymous",
                    isAuth: false,
                    isAdmin: false,
                    resourcesAllowed: [],
                    enterpriseApplicationData: [],
                    memberOf: [],
                };
                return __assign(__assign({}, state), user);
            }
    }
    return state;
};
exports.default = elstrUserReducer;
//# sourceMappingURL=elstrUserReducer.js.map